/**
 * The binary-sensor drawing family — the ids `BinarySensorAnimation.vue` draws.
 *
 * Its setting predates this work: the hub already stores the semantic type in
 * `settings.binary_sensor_subtype`, so the picker only had to become a drawing
 * picker instead of a second icon writer.
 */
import { binarySensorKindOf } from '../../devices/deviceWidgetTypes';
import { readSetting, type VariantFamily } from './types';

export const BINARY_SENSOR_VARIANTS: VariantFamily = {
  drawing: 'binary_sensor',
  settingKey: 'binary_sensor_subtype',
  title: ['Sensor type', 'Vrsta senzorja'],
  description: ['What this sensor watches. The tile draws it.', 'Kaj ta senzor opazuje. Ploščica to nariše.'],
  options: [
    { value: 'generic', icon: 'circle_notifications', label: ['Generic', 'Splošno'] },
    { value: 'door', icon: 'sensor_door', label: ['Door', 'Vrata'] },
    { value: 'window', icon: 'window', label: ['Window', 'Okno'] },
    { value: 'roof_window', icon: 'roofing', label: ['Roof window', 'Strešno okno'] },
    { value: 'contact', icon: 'sensors', label: ['Contact', 'Kontakt'] },
    { value: 'motion', icon: 'directions_walk', label: ['Motion', 'Gibanje'] },
    { value: 'smoke', icon: 'detector_smoke', label: ['Smoke', 'Dim'] },
    { value: 'flame', icon: 'local_fire_department', label: ['Flame', 'Plamen'] },
    { value: 'gas', icon: 'gas_meter', label: ['Gas', 'Plin'] },
    { value: 'leak', icon: 'water_damage', label: ['Water leak', 'Voda'] },
    { value: 'vibration', icon: 'vibration', label: ['Vibration', 'Tresenje'] },
    { value: 'tamper', icon: 'shield', label: ['Tamper', 'Poseg'] },
  ],
  defaultValue: 'generic',
  resolve: (device) =>
    binarySensorKindOf({
      ...device,
      subtype: String(readSetting(device.settings, 'binary_sensor_subtype') ?? device.subtype ?? ''),
    }),
};
